import React, { useState } from 'react';
import AwesomeSlider from 'react-awesome-slider';
import 'react-awesome-slider/dist/custom-animations/open-animation.css';
import 'react-awesome-slider/dist/styles.css';
import '../styles/carousel.css'


import Card from '../components/Card';
import projects from '../data/projects'

function Carousel () {
  const [movement, setMovement] = useState(true)
  const closeModal = () => {
    console.log('close')
    setMovement(true)
  }
  const openModal = () => {
    console.log('open')
    setMovement(false)
  }

  return (
    <div className="slider-container">

      <AwesomeSlider animation="openAnimation" mobileTouch={movement} >
        {projects.map(project => <div className="card-container"><Card project={project} key={project.id} closeModal={closeModal} openModal={openModal}/></div>)}

      </AwesomeSlider>

    </div>
  );

}


export default Carousel;